export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SIGN_OUT = '/signout';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const USER_PROFILE = "/profile"

export const REG_HOME = '/registration/home';
export const REG_COMPETITOR = '/registration/competitor';
export const REG_MENTOR = '/registration/mentor';
export const REG_DONE = "/registration/done";

export const DASHBOARD = "/dashboard";


export const USER_DASHBOARD = '/dash/user-dashboard';
export const RESOURCE_CENTER = '/dash/resource-center';
export const TEAMS = "/teams"
export const ANNOUNCEMENT = "/announcement"
export const BUILDWITHAI = "/buildwith-AI"
export const FAQ = "/faq"

export const SLACK_CHANNEL = "/digitaldefencehack.slack.com"